export default __webpack_public_path__ + "static/media/04.8f000dff.jpg";